/**
 * Shopify Utilities
 * Helpers para interactuar con Shopify Cart API
 */

/**
 * Obtiene el carrito actual
 * @returns {Promise<Object>} Cart object
 */
export async function getCart() {
  try {
    const response = await fetch('/cart.js');
    if (!response.ok) throw new Error('Failed to fetch cart');
    return await response.json();
  } catch (error) {
    console.error('Error fetching cart:', error);
    throw error;
  }
}

/**
 * Agrega un producto al carrito
 * @param {FormData} formData - Form data con id y quantity
 * @returns {Promise<Object>} Item agregado
 */
export async function addToCart(formData) {
  try {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      body: formData
    });

    if (!response.ok) throw new Error('Failed to add to cart');
    return await response.json();
  } catch (error) {
    console.error('Error adding to cart:', error);
    throw error;
  }
}

/**
 * Actualiza la cantidad de un item en el carrito
 * @param {number} line - Line item index (1-based)
 * @param {number} quantity - Nueva cantidad
 * @returns {Promise<Object>} Cart actualizado
 */
export async function updateCartItem(line, quantity) {
  try {
    const response = await fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ line, quantity })
    });

    if (!response.ok) throw new Error('Failed to update cart');
    return await response.json();
  } catch (error) {
    console.error('Error updating cart:', error);
    throw error;
  }
}

/**
 * Remueve un item del carrito
 * @param {number} line - Line item index (1-based)
 * @returns {Promise<Object>} Cart actualizado
 */
export async function removeCartItem(line) {
  return updateCartItem(line, 0);
}

/**
 * Limpia el carrito completo
 * @returns {Promise<Object>} Cart vac\u00edo
 */
export async function clearCart() {
  try {
    const response = await fetch('/cart/clear.js', {
      method: 'POST'
    });

    if (!response.ok) throw new Error('Failed to clear cart');
    return await response.json();
  } catch (error) {
    console.error('Error clearing cart:', error);
    throw error;
  }
}
